export const DAO_CODE = 'CUSTOMER' + '_CATEGORIES'  + '_DAO';
